var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.1667V10.8333C18.3333 6.23096 14.6024 2.5 10 2.5C5.39763 2.5 1.66666 6.23096 1.66666 10.8333V14.1667M6.25 17.5C5.0994 17.5 4.16666 16.5673 4.16666 15.4167V12.9167C4.16666 11.7661 5.0994 10.8333 6.25 10.8333C7.40059 10.8333 8.33333 11.7661 8.33333 12.9167V15.4167C8.33333 16.5673 7.40059 17.5 6.25 17.5ZM13.75 17.5C12.5994 17.5 11.6667 16.5673 11.6667 15.4167V12.9167C11.6667 11.7661 12.5994 10.8333 13.75 10.8333C14.9006 10.8333 15.8333 11.7661 15.8333 12.9167V15.4167C15.8333 16.5673 14.9006 17.5 13.75 17.5Z",
    stroke: "#4BC1C5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f095407b3153f0c828c833c41ef79f79.svg";
export { ForwardRef as ReactComponent };